import { TextBox } from '@superdispatch/ui-lab';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { InlineBulletItems } from './InlineBulletItems';

interface BrokerFeeLineProps {
  price: number | null;
  brokerFee: number | null;
}

export function BrokerFeeLine({ price, brokerFee }: BrokerFeeLineProps) {
  if (!price || !brokerFee) {
    return null;
  }

  const carrierNet = price - brokerFee;

  return (
    <TextBox aria-label="Broker fee">
      <InlineBulletItems>
        <span>
          <TextBox display="inline" variant="body-semibold">
            {formatCurrency(brokerFee, { minimumFractionDigits: 0 })}
          </TextBox>{' '}
          Broker fee
        </span>
        <span>
          Carrier gets{' '}
          {formatCurrency(carrierNet, { minimumFractionDigits: 0 })}
        </span>
      </InlineBulletItems>
    </TextBox>
  );
}
